import { InputType } from '../types';

const createInputTypeMap = <T extends Record<InputType, React.ComponentType<any>>>(map: T) => map;

export default createInputTypeMap;